import React from "react";

const AppSection = () => {
  return (
    <div className="app_section section-padding ">
      <div className="container px-sm-2 px-4">
        <div className="row">
          {/* IMAGE SECTION */}
          <div className="col-lg-6 ">
            <div className="app_img" data-aos='zoom-in' >
              <img src="/image/app-section/app-screen.png" className="img-fluid" alt="" />
            </div>
          </div>
          {/* CONTENT SECTION */}
          <div className="col-lg-6 mt-lg-1 mt-5">
            <div className="app_content">
              <p  data-aos='fade-up'  className="text-style text-green mb-4">OUR APP</p>
              <h2 data-aos='fade-up'  className="mb-4 fw-800 text-black">
                Let's Answer Some Of Your Questions Or Download Our App
              </h2>
              <p data-aos='fade-up' className="text-color text-justify-left mb-md-5 mb-4">
                In our dolore with people who are important to you,
                conversations that bring you to closer to each other and those
                who enjoy our dishes. Quisque pretium dolor turpis, quis blandit
                turpis semper ut. Nam malesuada eros nec luctus laoreet. Fusce
                sodales consequat velit eget dictum. Integer ornare magna.
              </p>

              <h4 data-aos='fade-up' className="my-md-5 my-4 fw-700 text-black">Over 70 million Downloads Worldwide</h4>

                <div className="d-flex gap-4 flex-wrap">
                    <img data-aos='zoom-in'  src="/image/app-section/app-store.png" className="  shadow-sm img-fluid" alt="" />
                    <img data-aos='zoom-in'  src="/image/app-section/play-store.png" className=" shadow-sm img-fluid" alt="" />
                </div>

            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default AppSection;
